import { Spin, Typography } from "antd";
import moment from "moment";
import { useEffect } from "react";
import { Socket } from "socket.io-client";
import { useGetOneTransaction } from "../../../../api/currency";
import { ButtonOutlinedCustom } from "../../../../components/button/buttonOulined";
import PaymentStatus from "../../../../types/paymentStatus.type";
import useResponsive from "../../../../utils/hooks/useResponsive";
import { formatNumber } from "../../../../utils/list.utils";
import StatusForm from "./status-form";
import TextContent from "./text-content";

const FormExchange = ({
  orderId,
  socket,
  handleCancelExchange,
  data,
  isLoading,
  refetch,
}: {
  orderId: string;
  socket: Socket<any, any>;
  handleCancelExchange: (id: any) => void;
  data: any;
  isLoading: boolean;
  refetch: any;
}) => {
  const { isTablet } = useResponsive();

  const reasonStatus = () => {
    switch (data?.data?.data?.status) {
      case PaymentStatus.PENDING:
        return "To finalize your exchange, please wait while your request is being reviewed.";
      case PaymentStatus.REJECTED:
        return data?.data?.data?.reason || "N/A";
      case PaymentStatus.CANCELLED:
        return (
          data?.data?.data?.reason ||
          "You’ve canceled the exchange order. Funds remain in your account."
        );
      case PaymentStatus.FAILED:
        return data?.data?.data?.reason || "N/A";
      case PaymentStatus.COMPLETED:
        return (
          data?.data?.data?.reason ||
          "Exchange has been completed. Check your portfolio for details."
        );
      default:
        return "";
    }
  };

  useEffect(() => {
    if (!orderId) return;
    const handleDetailWalletUpdated = () => {
      refetch();
    };
    socket.on(
      `user.walletOrder.${Number(orderId)}.updated`,
      handleDetailWalletUpdated
    );

    return () => {
      socket.off(
        `user.walletOrder.${Number(orderId)}.updated`,
        handleDetailWalletUpdated
      );
    };
  }, [socket, orderId, refetch]);

  return (
    <div>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            minHeight: "438px",
          }}
        >
          <Spin size="large" className="custom-spin" />
        </div>
      ) : (
        <div>
          <div className="form-history">
            <StatusForm
              status={data?.data?.data?.status || ""}
              content={reasonStatus()}
            />
            <div className="modal-balance">
              <div className="value-balance">
                <Typography style={{ fontSize: 16, color: "white" }}>
                  Amount
                </Typography>
                <Typography.Text className="text-gradient">
                  {formatNumber(
                    Number(data?.data?.data?.paymentAmount) || 0,
                    data?.data?.data?.paymentCurrencyDecimals
                  )}{" "}
                  <Typography.Text
                    className="text-gradient"
                    style={{
                      fontSize: isTablet ? "20px" : "24px",
                    }}
                  >
                    {data?.data?.data?.paymentCurrency}
                  </Typography.Text>
                </Typography.Text>
              </div>
            </div>
            <div className="form-history-content">
              <TextContent
                label="Receive"
                value={`${(
                  Number(data?.data?.data?.receiveAmount)
                ).toFixed(data?.data?.data?.receveCurrencyDecimals)} ${data?.data?.data?.receveCurrency || ""}`}
                color="rgba(242, 138, 40, 1)"
              />
            </div>
            <div className="form-history-content border-top">
              <TextContent label="Fees" value={
                Number(data?.data?.data?.fees) > 0
                  ? `${formatNumber(
                    Number(data?.data?.data?.fees) || 0,
                    data?.data?.data?.paymentCurrencyDecimals
                  )} ${data?.data?.data?.paymentCurrency || ""}`
                  : "0"
              } />
            </div>
            <div className="form-history-content border-top">
              <TextContent
                label="Order Time"
                value={moment(data?.data?.data?.createdAt).format(
                  "HH:mm:ss DD/MM/YYYY"
                )}
              />
            </div>
          </div>
          {data?.data?.data?.status === PaymentStatus.FAILED ||
            data?.data?.data?.status === PaymentStatus.PENDING ? (
            <div className="form-withdraw-button">
              <ButtonOutlinedCustom
                size={isTablet ? "medium" : "large"}
                text={"Cancel Exchange Money"}
                width={"100%"}
                className="outline-dangerous"
                onClick={() => handleCancelExchange(data?.data?.data?.id)}
              />
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default FormExchange;
